import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Header from '../components/header';
import Sidebar from '../components/sidebar';
import { Paginator } from 'primereact/paginator';

function Purchase() {
    const [Data, setData] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [selectedDate, setSelectedDate] = useState('');
    const [filteredData, setFilteredData] = useState(Data?.data);
    const [first, setFirst] = useState(0); 
    const [rows, setRows] = useState(10); 
   
    const fetchData = async (offset) => {
        try {
            const sendData = {next: offset}
            const response = await axios.get('https://api.trucoo.in/purchase/get-purchase/', {params: sendData});
            setData(response.data);
            console.log(response.data);
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    useEffect(() => {
        fetchData(0);
    }, []); 

    const handleSearchInputChange = (event) => {
        const query = event.target.value;
        setSearchQuery(query);
        applyFilters(query, selectedDate);
    };

    const handleDateChange = (e) => {
        setSelectedDate(e.target.value);
        applyFilters(searchQuery, e.target.value);
    };

    const applyFilters = (query, date) => {
        let filtered = Data?.data || [];
        
        // Apply text search filter
        if (query) {
            filtered = filtered.filter(purchase =>
                (purchase.invoiceNo?.toLowerCase().includes(query.toLowerCase())) ||
                (purchase.vender?.toLowerCase().includes(query.toLowerCase())) ||
                (purchase.item?.toLowerCase().includes(query.toLowerCase())) ||
                (purchase.price?.toString().includes(query.toLowerCase())) ||
                (purchase.quantity?.toString().includes(query.toLowerCase())) ||
                (purchase.totalAmount?.toString().includes(query.toLowerCase())) ||
                (purchase.gst?.toString().includes(query.toLowerCase())) ||
                (purchase.grandTotal?.toString().includes(query.toLowerCase())) ||
                (purchase.remark?.toLowerCase().includes(query.toLowerCase()))
            );
        }

        // Apply date filter
        if (date) {
            filtered = filtered.filter(purchase => {
                // Adjust this based on your actual date format
                const purchaseDate = new Date(purchase.date).toISOString().split('T')[0];
                return purchaseDate === date;
            });
        }

        setFilteredData(filtered);
    };

    const onPageChange = (event) => {
        setFirst(event.first);
        fetchData(event.first);
    };

    return (
        <>
            <Header />
            <Sidebar />

            <div className="content-wrapper">
                <div className="container-full">
                    <section className="content">
                        <div className="col-12">
                            <div className="box">
                                <div className="box-header with-border">
                                    <a href="/addPaymentMade" className="waves-effect waves-light btn mb-5 bg-gradient-info" style={{float: "right"}}>
                                        Add Payment Made
                                    </a>
                                    <h4 className="box-title">Payment Made</h4>
                                </div>
                                
                                <div className="box-body">
                                    <div className="table-responsive">
                                        <div className="d-flex align-items-center mb-5" style={{ gap: '10px' }}> 
                                            <div className="form-group" style={{marginRight: '10px'}}>
                                                <input 
                                                    type="text" 
                                                    className="form-control" 
                                                    placeholder="Search by invoice no, vender, item, etc."
                                                    value={searchQuery}
                                                    onChange={handleSearchInputChange}
                                                />
                                            </div>
                                            
                                            <div className="form-group">
                                                <input 
                                                    type="date" 
                                                    className="form-control"
                                                    value={selectedDate}
                                                    onChange={handleDateChange}
                                                />
                                            </div>
                                        </div>
                              
                                        <table className="table text-fade table-bordered table-hover display nowrap margin-top-10 w-p100">
                                            <thead>
                                                <tr className="text-dark">
                                                    <th>SI.NO</th>
                                                    <th>Invoice No</th>
                                                    <th>Vender</th>
                                                    <th>Date</th>
                                                    <th>Item</th>
                                                    <th>Price</th>
                                                    <th>Quantity</th>
                                                    <th>Total</th>
                                                    <th>GST</th>
                                                    <th>grand Total</th>
                                                    <th>Remark</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {(searchQuery || selectedDate) && filteredData?.length > 0 ? (
                                                    <>
                                                        {filteredData.map((purchase, index) => ( 
                                                            <tr key={purchase.id}>
                                                                <td>{index + 1}</td>
                                                                <td>{purchase.invoiceNo}</td>
                                                                <td>{purchase.vender}</td>
                                                                <td>{purchase.date}</td>
                                                                <td>{purchase.item}</td>
                                                                <td>{purchase.price}</td>
                                                                <td>{purchase.quantity}</td>
                                                                <td>{purchase.totalAmount}</td>
                                                                <td>{purchase.gst}</td>
                                                                <td>{purchase.grandTotal}</td>
                                                                <td>{purchase.remark}</td>
                                                            </tr>
                                                        ))}
                                                    </>
                                                ) : (searchQuery || selectedDate) && filteredData?.length === 0 ? (
                                                    <tr>
                                                        <td colSpan="11">No payments found</td>
                                                    </tr>
                                                ) : (
                                                    <>
                                                        {Data?.data?.map((purchase, index) => (
                                                           <tr key={purchase.id}>
                                                                <td>{index + 1}</td>
                                                                <td>{purchase.invoiceNo}</td>
                                                                <td>{purchase.vender}</td>
                                                                <td>{purchase.date}</td>
                                                                <td>{purchase.item}</td>
                                                                <td>{purchase.price}</td>
                                                                <td>{purchase.quantity}</td>
                                                                <td>{purchase.totalAmount}</td>
                                                                <td>{purchase.gst}</td>
                                                                <td>{purchase.grandTotal}</td>
                                                                <td>{purchase.remark}</td>
                                                            </tr>
                                                        ))}
                                                    </>
                                                )}
                                            </tbody>	
                                        </table>
                                        <Paginator 
                                            className="custom-paginator" 
                                            first={first} 
                                            rows={rows} 
                                            totalRecords={Data?.ReadCount}  
                                            onPageChange={onPageChange} 
                                        />
                                    </div>              
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </>
    );
}

export default Purchase;